"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * TPC Enrollment
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PreIdentityStepToJSON = exports.PreIdentityStepFromJSONTyped = exports.PreIdentityStepFromJSON = void 0;
function PreIdentityStepFromJSON(json) {
    return PreIdentityStepFromJSONTyped(json, false);
}
exports.PreIdentityStepFromJSON = PreIdentityStepFromJSON;
function PreIdentityStepFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'everUsedPreviousName': json['everUsedPreviousName'],
        'everUsedAlias': json['everUsedAlias'],
    };
}
exports.PreIdentityStepFromJSONTyped = PreIdentityStepFromJSONTyped;
function PreIdentityStepToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'everUsedPreviousName': value.everUsedPreviousName,
        'everUsedAlias': value.everUsedAlias,
    };
}
exports.PreIdentityStepToJSON = PreIdentityStepToJSON;
//# sourceMappingURL=PreIdentityStep.js.map